import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 264 107",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "99",
      y: "41",
      width: "66",
      height: "24",
      rx: "4",
      fill: "var(--dt-badge-color-background-critical)",
      id: "badge"
    }, null, -1),
    _createElementVNode("rect", {
      x: "108",
      y: "49",
      width: "48",
      height: "8",
      rx: "4",
      fill: "var(--dt-color-foreground-secondary)",
      id: "text"
    }, null, -1)
  ]))]))
}
export default { render: render }